import React, {PureComponent} from 'react';
import {Card} from 'reactstrap';

import './BackCard.scss';

export default class BackCard extends PureComponent {
  render() {
    return<Card className="search-card-back h-100 text-center">
      {this.props.children}
    </Card>
  }
}